<div class="dialog-content">
<div mat-dialog-title class="dialog-text">Deleting Item</div>
<div class="underline"></div>
<div mat-dialog-content class="dialog-text">{{data}}</div>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" (click)="confirmedOption()">Yes</button>
  <button mat-raised-button class="dialog-btn" (click)="canceledOption()">No</button>
</div>
</div>
